export default __webpack_public_path__ + "v1.18.25/static/media/link-arrow.a76636ac.svg";